window.axios = require('axios');

let token = document.head.querySelector('meta[name="csrf-token"]');
let auth_token = document.head.querySelector('meta[name="auth-token"]');

if (auth_token) {
    window.axios.defaults.headers.common['Authorization'] = 'Bearer '+auth_token.content;
}
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

console.log('Made by:\n' +
    '    ___                             ______                __  _               ____                 __                                 __ \n' +
    '   /   |  ____  ___  _________     / ____/_______  ____ _/ /_(_)   _____     / __ \\___ _   _____  / /___  ____  ____ ___  ___  ____  / /_\n' +
    '  / /| | / __ \\/ _ \\/ ___/ __ \\   / /   / ___/ _ \\/ __ `/ __/ / | / / _ \\   / / / / _ \\ | / / _ \\/ / __ \\/ __ \\/ __ `__ \\/ _ \\/ __ \\/ __/\n' +
    ' / ___ |/ /_/ /  __/ /  / /_/ /  / /___/ /  /  __/ /_/ / /_/ /| |/ /  __/  / /_/ /  __/ |/ /  __/ / /_/ / /_/ / / / / / /  __/ / / / /_  \n' +
    '/_/  |_/ .___/\\___/_/   \\____/   \\____/_/   \\___/\\__,_/\\__/_/ |___/\\___/  /_____/\\___/|___/\\___/_/\\____/ .___/_/ /_/ /_/\\___/_/ /_/\\__/  \n' +
    '      /_/                                                                                             /_/                                \n');
console.log('https://www.aperobuilt.it');

window.$ = window.jQuery = require('jquery');
import Sortable from 'sortablejs';
window.Sortable = Sortable;
import SignaturePad from "signature_pad";
window.SignaturePad = SignaturePad;
import autosize from "autosize/dist/autosize";
window.autosize = autosize;

//
// Vue Setup
//

import {createApp} from 'vue';

import FlashAlert from './vue-components/FlashAlert.vue';
import VueFlashAlertContainer from './vue-components/VueFlashAlertContainer.vue';
import JudgingPanels from "./vue-components/JudgingPanels.vue";
import JudgingInstructions from "./vue-components/JudgingInstructions.vue";
import JudgingFormQuestions from "./vue-components/JudgingFormQuestions.vue";
import JudgingPdfMaterialBrowser from "./vue-components/JudgingPdfMaterialBrowser.vue";
import PdfViewer from "./vue-components/PdfViewer.vue";
import PdfViewerModal from "./vue-components/PdfViewerModal.vue";
import QuestionPopup from "./vue-components/QuestionPopup.vue"

// Auth Components
import AuthVerifySelectMethod from './vue-components/Auth/AuthVerifySelectMethod.vue';
import AuthVerifyEnterCode from './vue-components/Auth/AuthVerifyEnterCode.vue';

const entryId = document.getElementById('entryId') ? document.getElementById('entryId').innerText : null;

const app = createApp({
    components: {
        FlashAlert,
        VueFlashAlertContainer,
        JudgingPanels,
        JudgingInstructions,
        JudgingFormQuestions,
        JudgingPdfMaterialBrowser,
        PdfViewer,
        PdfViewerModal,
        AuthVerifySelectMethod,
        AuthVerifyEnterCode,
        QuestionPopup,
    },
    data() {
        return {
            active: localStorage.getItem('hide-instructions-' + entryId) != 1,
            activeEmail: false,
            activeCC: false,
            greyCC: true,
            greyEmail: true,
            selectItems: true,
            totalDue: 0,
            boxesChecked: true,
        };
    },

    created: function() {

    },
    methods: {
        liked: function() {
            if (this.active) {
                localStorage.setItem('hide-instructions-' + entryId, '1')
            } else {
                localStorage.removeItem('hide-instructions-' + entryId)
            }
            this.active = !this.active;
        },
        showEmail: function() {
            if (this.activeEmail) {
                this.greyCC = '';
            } else {
                this.greyCC = 'disable';
                this.greyEmail = '';
            }
            this.activeCC = false;
            this.activeEmail = !this.activeEmail;
        },
        showCC: function() {
            if (this.activeCC) {
                this.greyEmail = '';
            } else {
                this.greyCC = '';
                this.greyEmail = 'disable';
            }
            this.activeEmail = false;
            this.activeCC = !this.activeCC;
        },
    },
    computed: {
        iconClass: function() {
            return this.active ? 'fa fa-caret-up' : 'fa fa-caret-down'
        },
        buttonText: function () {
            return this.active ? 'Hide Instructions' : 'Show Instructions'
        },
    }
});

// Disable interpolation in the client side vue compiler to prevent XSS when outputting variables
// server side using blade within the root component template (<div id=app>)
// Vue provides no way to disable interpolation, so we set the delimiters to random strings.
const generateRandomString = () => Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);
app.config.compilerOptions.delimiters = [`{{${generateRandomString()}}}`, `{{${generateRandomString()}}}`];

app.mount('#home');